import { useDispatch, useSelector } from "react-redux";

import { IconButton } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import useTargetAccountsTrackingService from "app/pages/sales-intelligence/hooks/useTargetAccountsTrackingService";
import { toggleOpportunityListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { selectAllUniqueWebsites } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";

import { StyledEmptyStaticListContainer, StyledIcon, StyledTextBlock } from "./styles";

const EmptyStaticListContainer = () => {
    const dispatch = useDispatch();
    const allUniqueOpportunities = useSelector(selectAllUniqueWebsites);
    const trackingService = useTargetAccountsTrackingService();
    const handleAddButtonClick = () => {
        trackingService.trackAddListClicked(allUniqueOpportunities.length);
        dispatch(toggleOpportunityListModal(true));
    };

    return (
        <StyledEmptyStaticListContainer>
            <StyledIcon iconName="empty-state-static-list-secondary" />
            <div>
                <I18n
                    dangerouslySetInnerHTML
                    component={StyledTextBlock}
                >
                    {"si.my-list.static-list.empty-state.description"}
                </I18n>
                <IconButton
                    type="primary"
                    iconName="plus"
                    iconSize="xs"
                    onClick={handleAddButtonClick}
                >
                    {translate("si.my-list.static-list.button.add-new-list")}
                </IconButton>
            </div>
        </StyledEmptyStaticListContainer>
    );
};

export default EmptyStaticListContainer;
